import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const EventService = {
  /**
   * @description Get Continents list
   *
   * @returns {object}
   */
  getContinents(params) {
    const getContinentsURL = `${API_HOST}/${API_VERSION}/concert/continents`
    return Axios
      .get(getContinentsURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get Continent by continent id
   *
   * @returns {object}
   */
  getContinentById(continentId, params) {
    const getContinentURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}`
    return Axios
      .get(getContinentURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get country list
   *
   * @returns {object}
   */
  getCountries(continentId, params) {
    const getCountriesURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}/countries`
    return Axios
      .get(getCountriesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get country by country id
   *
   * @returns {object}
   */
  getCountryById(continentId, conuntryId, params) {
    const getCountryURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}/countries/${conuntryId}`
    return Axios
      .get(getCountryURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get state list
   *
   * @returns {object}
   */
  getStates(continentId, conuntryId, params) {
    const getStatesURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}/countries/${conuntryId}/states`
    return Axios
      .get(getStatesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get state list
   *
   * @returns {object}
   */
  getStateById(continentId, conuntryId, stateId, params) {
    const getStateURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}/countries/${conuntryId}/states/${stateId}`
    return Axios
      .get(getStateURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get city list
   *
   * @returns {object}
   */
  getStateCities(continentId, conuntryId, stateId, params) {
    const getStateCitiesURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}/countries/${conuntryId}/states/${stateId}/cities`
    return Axios
      .get(getStateCitiesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get country city list
   *
   * @returns {object}
   */
  getCountryCities(continentId, conuntryId, params) {
    const getCountryCitiesURL = `${API_HOST}/${API_VERSION}/concert/continents/${continentId}/countries/${conuntryId}/cities`
    return Axios
      .get(getCountryCitiesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get City list
   *
   * @returns {object}
   */
  getCities(params) {
    const getCitiesURL = `${API_HOST}/${API_VERSION}/concert/cities`
    return Axios
      .get(getCitiesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get Venues list
   *
   * @returns {object}
   */
  getVenues(query, params) {
    const getVenuesURL = `${API_HOST}/${API_VERSION}/concert/venues`
    params.q = query
    // const params = {
    //   q: query,
    //   page,
    //   per_page: perPage
    // }
    return Axios
      .get(getVenuesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },

  /**
   * @description Get specific city info
   *
   * @returns {object}
   */
  getCityInfo(cityId, params) {
    const getCitiesURL = `${API_HOST}/${API_VERSION}/concert/cities/${cityId}`
    return Axios
      .get(getCitiesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },

  /**
   * @description Get all event list data
   *
   * @returns {object}
   */
  getEventList(q, page = 1, perPage = 100, type) {
    const apiURL = `${API_HOST}/${API_VERSION}/concert/events`
    const params = {
      q,
      page,
      per_page: perPage,
      type
    }
    // const apiURL = `https://dev.muzikair.com:11412/v3/event/list?limit=${perPage}&paging=${page}`
    return Axios
      .get(apiURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get event by id
   *
   * @returns {object}
   */
  getEventById(eventId) {
    const apiURL = `${API_HOST}/${API_VERSION}/concert/events/${eventId}`
    // const apiURL = `https://dev.muzikair.com:11412/v3/events/${eventId}`
    return Axios.request({
      method: 'GET',
      url: apiURL,
      headers: {
        Accept: 'application/json'
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default EventService
